module.exports = __webpack_public_path__ + "img/4a12753c6f3d4ecabd91496cdebb5a91.9aa12f26.png";